import type { GridProps } from '@petsmart-ui/sparky';
import { Grid } from '@petsmart-ui/sparky';
import { trackCardUpClick } from '@libs/analytics';
import PromoCard from '../PromoCard';
import { propsImagesItems } from '../../utils/propsImagesItems';
import type { CardUpProps } from './types';

const validVariants = [
    '2up',
    'side-by-side',
    '1-3up',
    '3up',
    '2-4up',
    '4up',
    '4Stack',
    '3-6up',
    '2-3-4-6up',
    '1-2-4up',
    '1-2up',
    'Info',
    '2up Offer',
];

const isValidGridVariantGuard = (variant: string): boolean => validVariants.includes(variant);

export default function CardUpVariant({
    header: title,
    cards,
    variant,
    sliceMax,
    sysId,
    pathname,
}: Readonly<CardUpProps>) {
    if (!isValidGridVariantGuard(variant)) {
        return null;
    }
    return (
        <Grid
            variant={variant as GridProps['variant']}
            key={sysId}
            data-testid={`card-${variant}`}
            className={`card-up__card${variant}-grd`}
        >
            {cards.slice(0, sliceMax).map((card, index) => (
                <Grid.Item key={card.sysId}>
                    <PromoCard
                        description={card.description}
                        link={variant === 'Info' ? undefined : card.link}
                        imgAlt={card.image.webAltText}
                        imageItems={propsImagesItems(card.image)}
                        data-test-id="promo-card"
                        onClick={() => {
                            if (variant === 'Info') {
                                return;
                            }
                            trackCardUpClick({
                                variant,
                                title,
                                cardName: card.header || card.description,
                                cardPosition: index + 1,
                                link: card?.link?.webUrl,
                                linkText: `${card.header}${card.description ? ` ${card.description}` : ''}`,
                                pathname,
                                promoType: `card-up__card${variant}-grd`,
                            });
                        }}
                        header={card.header}
                    />
                </Grid.Item>
            ))}
        </Grid>
    );
}
